import React from 'react';
import {Route, Switch, Router, Redirect, useParams} from 'react-router-dom';
import Account from 'Account.js';
import AccountCashback from 'AccountCashback.js';
import AccountSessionHistory from 'AccountSessionHistory.js';
import AccountDeposit from 'AccountDeposit';
import AccountWithdraw from 'AccountWithdraw';
import AccountBonus from 'AccountBonus.js';

const AccountRoute = (props) => {


    return (
        <Switch>
            <Route path="/konto/historia-sesji" component={AccountSessionHistory}/>
            <Route path="/konto/cashback" render={(props) => <AccountCashback {...props}/>}/>
            <Route path='/konto/wplata' component={AccountDeposit} />
            <Route path='/konto/wyplata' component={AccountWithdraw} />
            <Route path="/konto" component={Account}/>
            <Route path="/konto/bonus" component={AccountBonus}/>
            <Route path="/konto/edycja" render={(props) => <div>edycja profilu</div>}/>
            <Redirect to="/konto/edycja"/>
        </Switch> 
    )
};

export default AccountRoute;